const Pacientes = [
    { nombre: 'Jose Catalan', edad: 102,  peso: 300, estatura: 210, imgName: 'paciente1.jpg'},
    { nombre: 'Delfina Salas', edad: 26, peso: 70, estatura: 150, imgName: 'paciente2.jpg'},
    { nombre: 'Laureano Macias', edad: 30, peso: 143, estatura: 160, imgName: 'paciente3.jpg'},
    { nombre: 'Gabriel Rodrigues', edad: 20, peso: 145, estatura: 70, imgName: 'paciente4.jpg'},
  ];

  export default Pacientes;

